import { useMutation } from '@tanstack/react-query';
import useGetMutationFn from '../use-get-mutation-fn';

type MutationPayload = { forward_id: string };

type MutationResponse = {
  status: number;
  data: { success: boolean };
};

export const useDeleteWebhookForwardMutation = () => {
  const mutationFn = useGetMutationFn<MutationPayload, MutationResponse>({
    defaultErrorMessage: 'An unexpected error occurred while deleting the webhook forward',
    endpoint: ({ forward_id }) => `/api/admin/whatsapp/webhook-forward/${forward_id}`,
    method: 'DELETE',
  });

  return useMutation<MutationResponse, Error, MutationPayload>({ mutationFn });
};
